module.exports = __webpack_public_path__ + "static/media/Contacto.50d14353.jpg";